// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".landing h2{line-height:1.6}.landing h3{font-size:1.25rem}.landing #benefits img{width:30%}\n", ""]);
// Exports
module.exports = exports;
